// company.js - Vuex module for company data
import axios from "axios";

const state = {
  companies: [],
  selectedCompany: null,
  loading: false,
  error: null,
};

const getters = {
  companies: (state) => state.companies,
  selectedCompany: (state) => state.selectedCompany,
  isLoading: (state) => state.loading,
  hasError: (state) => !!state.error,
  errorMessage: (state) => state.error,
};

const mutations = {
  SET_COMPANIES(state, companies) {
    state.companies = companies;
  },
  SET_SELECTED_COMPANY(state, company) {
    state.selectedCompany = company;
  },
  SET_LOADING(state, isLoading) {
    state.loading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  },
};

const actions = {
  // Fetch all companies
  async fetchCompaniesIDS({ commit }) {
    commit("SET_LOADING", true);
    commit("CLEAR_ERROR");

    try {
      const response = await axios.get("/api/companies/ids");
      const companies = response.data.data;

      commit("SET_COMPANIES", companies);
      return companies;
    } catch (error) {
      console.error("Error fetching companies:", error);
      commit("SET_ERROR", "Failed to fetch companies");
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // Set companies directly (useful when data is already fetched)
  setCompanies({ commit }, companies) {
    commit("SET_COMPANIES", companies);
  },

  // Select a company by ID
  selectCompany({ commit, state }, companyId) {
    const company = state.companies.find((c) => c.id === parseInt(companyId));
    if (company) {
      localStorage.setItem("selectedCompanyId", company.id);
    }
    commit("SET_SELECTED_COMPANY", company || null);
    return company;
  },

  // Clear selected company
  clearSelectedCompany({ commit }) {
    commit("SET_SELECTED_COMPANY", null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
